module.exports = __webpack_public_path__ + "img/hello.c50f038e.png";